import { useMemo } from 'react';
import { useSpotMarkets } from './useSpotMarkets';

export const useSpotMarketsSortedByMarketIndex = () => {
	const spotMarkets = useSpotMarkets();
	return useMemo(() => {
		const spotMarketArray = new Array(
			Math.max(...spotMarkets.map((spotMarket) => spotMarket.marketIndex)) + 1
		);
		spotMarkets
			.sort((a, b) => a.marketIndex - b.marketIndex)
			.forEach((spotMarket) => {
				spotMarketArray[spotMarket.marketIndex] = spotMarket;
			});

		return spotMarketArray;
	}, [spotMarkets]);
};
